export default __webpack_public_path__ + "static/media/amazonclone.531c8eb7.png";